<template>
  <div class="news-list">
    <CCard>
      <CCardHeader class="d-flex justify-content-between align-items-center">
        <strong>نوشته‌ها</strong>
        <CButton color="primary" size="sm" @click="$router.push('/dashboard/news/add-news')"><CIcon name="cil-plus" size="sm"/> نوشته جدید</CButton>
      </CCardHeader>
      <CCardBody>
        <ServerTable ref="table" url="/api/admin/blog/get_posts" :fields="fields" :tabs="tabs" :params="params"
                     search-placeholder="عنوان یا نامک" empty-text="نوشته‌ای یافت نشد">
          <template #toolbar>
            <select v-model="cat" class="form-control form-control-sm" style="max-width:200px" aria-label="دسته‌بندی">
              <option value="">همه دسته‌ها</option>
              <option v-for="c in cats" :key="c.id" :value="c.id">{{ c.name }}</option>
            </select>
          </template>
          <template #image="{item}"><td style="width:64px"><img v-if="item.image" :src="item.image" class="nl-thumb" alt=""><span v-else class="nl-thumb nl-thumb--empty"></span></td></template>
          <template #name="{item}"><td><a href="#" @click.prevent="edit(item)"><strong>{{ item.name }}</strong></a>
            <div class="small text-muted" dir="ltr">/blog/{{ item.slug }}</div></td></template>
          <template #categories="{item}"><td class="small">{{ item.categories.join('، ') || '—' }}</td></template>
          <template #status="{item}"><td><span :class="['badge', item.status === 1 ? 'badge-success' : 'badge-secondary']">{{ item.status === 1 ? 'منتشر شده' : 'پیش‌نویس' }}</span></td></template>
          <template #publish_date="{item}"><td class="text-muted small">{{ get_date_time(item.publish_date || item.created_at) }}</td></template>
          <template #operation="{item}">
            <td class="text-nowrap">
              <CButton color="primary" variant="outline" square size="sm" title="ویرایش" @click="edit(item)"><CIcon name="cil-pencil" size="sm"/></CButton>
              <CButton color="info" variant="outline" square size="sm" title="مشاهده" @click="view(item)"><CIcon name="cil-external-link" size="sm"/></CButton>
              <CButton color="danger" variant="outline" square size="sm" title="حذف" @click="remove(item)"><CIcon name="cil-trash" size="sm"/></CButton>
            </td>
          </template>
        </ServerTable>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import axios from "@/api/http";
import ServerTable from "@/views/includes/ServerTable.vue";
import { confirmAsk, apiToast } from "@/utils/confirm";

export default {
  name: 'NewsList',
  components: { ServerTable },
  data() {
    return {
      cat: '',
      cats: [],
      tabs: [{ value: '', label: 'همه' }, { value: 1, label: 'منتشر شده' }, { value: 2, label: 'پیش‌نویس' }],
      fields: [
        { key: 'image', label: '' },
        { key: 'name', label: 'عنوان' },
        { key: 'categories', label: 'دسته‌ها' },
        { key: 'status', label: 'وضعیت' },
        { key: 'publish_date', label: 'تاریخ' },
        { key: 'views', label: 'بازدید' },
        { key: 'comments', label: 'دیدگاه' },
        { key: 'operation', label: 'عملیات' },
      ],
    }
  },
  computed: {
    params() { return this.cat ? { cat: this.cat } : (this.$route.params.cat_id ? { cat: this.$route.params.cat_id } : {}) },
  },
  mounted() {
    axios.post('/api/admin/blog/get_categories', {}, { show_pros: false }).then((res) => { this.cats = (res.data && res.data.orders) || [] }).catch(() => {})
  },
  methods: {
    edit(item) { this.$router.push('/dashboard/news/edit-news/' + item.id) },
    view(item) { window.open(String(localStorage.getItem('web_address') || '').replace(/\/+$/, '') + '/blog/' + item.slug, '_blank') },
    async remove(item) {
      if (!(await confirmAsk(this, 'نوشته «' + item.name + '» حذف شود؟'))) return
      axios.post('/api/admin/blog/delete_post', { post_id: item.id }).then((res) => {
        apiToast(this, res)
        if (res.data && !res.data.error) this.$refs.table.removeRow(item.id)
      }).catch((e) => console.log(e))
    },
  },
}
</script>

<style scoped>
.nl-thumb { width: 52px; height: 40px; object-fit: cover; border-radius: 6px; display: block; }
.nl-thumb--empty { background: #f1f5f9; }
</style>
